import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Newspaper, Mic, BookOpen, Inbox, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const CONTENT_CARDS = [
  { kind: "articles", label: "Articles", icon: FileText },
  { kind: "news", label: "News", icon: Newspaper },
  { kind: "interviews", label: "Interviews", icon: Mic },
  { kind: "magazines", label: "Magazines", icon: BookOpen },
];

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => { try { setStats(await api.adminStats()); } catch {} })();
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="overline overline-muted mb-4">Overview</div>
      <h1 className="font-display text-ink text-4xl md:text-5xl leading-[1.05] tracking-[-0.015em]">
        Manage the publication.
      </h1>
      <p className="mt-3 text-ink-soft max-w-2xl">Create, edit and publish articles, news, interviews and magazine editions. Changes are reflected on the live site immediately.</p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {CONTENT_CARDS.map((c) => {
          const s = stats?.[c.kind];
          return (
            <Link
              key={c.kind}
              to={`/admin/${c.kind}`}
              data-testid={`dashboard-card-${c.kind}`}
              className="editorial-card p-6 group block"
            >
              <div className="flex items-center justify-between mb-6">
                <c.icon size={20} strokeWidth={1.4} className="text-ink" />
                <ArrowRight size={16} className="text-ink-muted group-hover:text-ink group-hover:translate-x-1 transition-all" />
              </div>
              <div className="font-display text-ink text-2xl">{c.label}</div>
              <div className="mt-4 flex items-center gap-4 text-xs text-ink-muted font-mono-editorial">
                <span><span className="text-ink font-medium">{s?.total ?? "—"}</span> total</span>
                <span><span className="text-ink font-medium">{s?.published ?? "—"}</span> live</span>
                <span><span className="text-ink font-medium">{s?.draft ?? "—"}</span> draft</span>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-14">
        <div className="overline overline-muted mb-4">Inbox</div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            { key: "contact", label: "Contact messages" },
            { key: "newsletter", label: "Newsletter signups" },
            { key: "featured", label: "Featured applications" },
          ].map((m) => (
            <Link
              key={m.key}
              to={`/admin/messages/${m.key}`}
              data-testid={`dashboard-messages-${m.key}`}
              className="editorial-card p-6 group block"
            >
              <div className="flex items-center justify-between mb-6">
                <Inbox size={20} strokeWidth={1.4} className="text-ink" />
                <ArrowRight size={16} className="text-ink-muted group-hover:text-ink group-hover:translate-x-1 transition-all" />
              </div>
              <div className="font-display text-ink text-xl">{m.label}</div>
              <div className="mt-3 font-mono-editorial text-xs text-ink-muted">
                <span className="text-ink font-medium">{stats?.messages?.[m.key] ?? "—"}</span> received
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
